import { createContext } from "react";

export enum WebsiteContextKey {
  updateAdopterModalStatus = "updateAdopterModalStatus",
}

export class websiteContext {
  adopterModalStatus: boolean = false;
  onSaveWebsiteCallback: (key: WebsiteContextKey, value: any) => void = () => {};
}

export const WebsiteContext = createContext<websiteContext>(new websiteContext());
